import { Controller } from "@hotwired/stimulus"

// Shows/hides an offline banner as connectivity changes.
export default class extends Controller {
  static targets = ["overlay"]

  connect() {
    this._onOnline  = () => this.#setOnline()
    this._onOffline = () => this.#setOffline()
    window.addEventListener("online",  this._onOnline)
    window.addEventListener("offline", this._onOffline)
    if (!navigator.onLine) this.#setOffline()
  }

  disconnect() {
    window.removeEventListener("online",  this._onOnline)
    window.removeEventListener("offline", this._onOffline)
  }

  #setOnline()  { this.overlayTarget.hidden = true  }
  #setOffline() { this.overlayTarget.hidden = false }
}
